const FEATURES = [
  {
    id: 1,
    icon: 'ri-book-open-line',
    title: '海量漫画资源',
    desc: '收录五万余部漫画作品，涵盖热血、恋爱、奇幻、悬疑、搞笑等全品类，持续扩充中。',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '每日同步更新',
    desc: '热门连载漫画第一时间同步更新，日均更新超200部，追更党永不错过最新话。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '完全免费阅读',
    desc: '全站漫画免费阅读，无需注册、无需付费、无需会员，零门槛畅享全本漫画。',
  },
  {
    id: 4,
    icon: 'ri-smartphone-line',
    title: '多端适配阅读',
    desc: '支持电脑、平板、手机多设备访问，自适应阅读模式，随时随地畅快追漫。',
  },
  {
    id: 5,
    icon: 'ri-heart-line',
    title: '纯净阅读体验',
    desc: '极简界面设计，无弹窗、无强制广告，专注为读者打造沉浸式漫画阅读环境。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择香蕉漫画
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            五大核心优势，为你打造最佳的免费漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {FEATURES.map((item) => (
            <div
              key={item.id}
              className="group p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}